(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beleno-kaminholz-product-grid"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-bkh-grid]').forEach((root) => {
  const cards = Array.from(root.querySelectorAll('[data-bkh-product]'));
  const list = root.querySelector('[data-bkh-product-list]');
  const checkboxes = Array.from(root.querySelectorAll('[data-bkh-filter]'));
  const price = root.querySelector('[data-bkh-price]');
  const priceLabel = root.querySelector('[data-bkh-price-label]');
  const count = root.querySelector('[data-bkh-count]');
  const reset = root.querySelector('[data-bkh-reset]');
  const sort = root.querySelector('[data-bkh-sort]');
  const empty = root.querySelector('[data-bkh-no-results]');

  if (!cards.length || !list) return;

  const euro = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  });

  const getSelected = (group) =>
    checkboxes
      .filter((input) => input.dataset.bkhFilter === group && input.checked)
      .map((input) => input.value);

  const matchesGroup = (card, group, selected) =>
    selected.length === 0 || selected.includes(card.dataset[group]);

  const sortCards = () => {
    const mode = sort ? sort.value : 'featured';
    const sorted = [...cards].sort((a, b) => {
      if (mode === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
      if (mode === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
      if (mode === 'title-asc') return a.dataset.title.localeCompare(b.dataset.title, 'de');
      return Number(a.dataset.originalOrder) - Number(b.dataset.originalOrder);
    });
    sorted.forEach((card) => list.appendChild(card));
  };

  const update = () => {
    const selectedColors = getSelected('color');
    const selectedSizes = getSelected('size');
    const selectedBuilds = getSelected('build');
    const maxPrice = price ? Number(price.value) : Infinity;

    let visible = 0;

    cards.forEach((card) => {
      const show =
        matchesGroup(card, 'color', selectedColors) &&
        matchesGroup(card, 'size', selectedSizes) &&
        matchesGroup(card, 'build', selectedBuilds) &&
        Number(card.dataset.price) <= maxPrice;

      card.hidden = !show;
      if (show) visible += 1;
    });

    if (count) count.textContent = visible === 1 ? '1 Produkt' : visible + ' Produkte';
    if (empty) empty.hidden = visible !== 0;
    if (priceLabel && price) priceLabel.textContent = euro.format(Number(price.value) / 100);

    const hasChecks = checkboxes.some((input) => input.checked);
    const hasPrice = price && Number(price.value) < Number(price.max);
    if (reset) reset.hidden = !(hasChecks || hasPrice);

    sortCards();
  };

  root.querySelectorAll('[data-bkh-option-count]').forEach((node) => {
    const [group, value] = node.dataset.bkhOptionCount.split(':');
    const optionCount = cards.filter((card) => card.dataset[group] === value).length;
    node.textContent = '(' + optionCount + ')';
  });

  checkboxes.forEach((input) => input.addEventListener('change', update));
  if (price) {
    price.addEventListener('input', update);
    price.addEventListener('change', update);
  }
  if (sort) sort.addEventListener('change', update);

  if (reset) {
    reset.addEventListener('click', () => {
      checkboxes.forEach((input) => {
        input.checked = false;
      });
      if (price) price.value = price.max;
      if (sort) sort.value = 'featured';
      update();
    });
  }

  update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
